module.exports = __webpack_public_path__ + "img/logo-footer-3.7727ab8c.png";